export const REACT_APP_S3_ASSETS_URL = process.env
    .REACT_APP_S3_ASSETS_URL
    ? process.env.REACT_APP_S3_ASSETS_URL
    : "";
export const REACT_APP_META_INFO_ROBOTS = process.env
    .REACT_APP_META_INFO_ROBOTS
    ? process.env.REACT_APP_META_INFO_ROBOTS
    : "";